export const state = {
        siteInfo: {
            title: 'vue-admin-example',
            brandUrl: '/images/headerLogo.png'
        },
        company: [],
        listedCompany: [],
        carbonCompany:[],
    };

export const getters = {
    siteInfo(state) {
        return state.siteInfo;
    },
    company(state){
      return state.company
    },
    listedCompany(state){
      return state.listedCompany
    },
    carbonCompany(state){
      return state.carbonCompany
    },
};

export const actions = {

};

export const mutations = {
  setCompany(state, list){
    state.company = list
  },
  setListedCompany(state, list){
    state.listedCompany = list
  },
  setCarbonCompany(state, list){
    state.carbonCompany = list
  }
};
